import axios from 'axios';

const url = process.env.NODE_ENV === 'development' ? `http://localhost:4000` : `/api`;

export async function fetchData() {
  try {
    let data;
    await axios
      .get(url)
      .then(res => (data = res.data))
      .catch(err => {
        console.error('API call failure:', JSON.stringify(err));
        data = err;
      });

    if (data) {
      const hashmap = {};
      data.forEach(agency => {
        const { agency_id: _agency_id, ...agencyDataToCheck } = agency;
        const agencyDataToCheckAsString = JSON.stringify(agencyDataToCheck);
        if (!hashmap[agencyDataToCheckAsString]) hashmap[agencyDataToCheckAsString] = agency;
      });
      const paredDownData = Object.values(hashmap);

      const cleanedAndParedDownData =
        paredDownData &&
        paredDownData.map(
          ({
            agency_name,
            agency_url,
            agency_id,
            gtfs_static,
            gtfs_rt_vehicle_positions,
            gtfs_rt_trip_updates,
            gtfs_rt_alerts,
          }) => [
            { agency_name, agency_url, agency_id },
            gtfs_static,
            gtfs_rt_vehicle_positions,
            gtfs_rt_trip_updates,
            gtfs_rt_alerts,
          ]
        );

      return cleanedAndParedDownData;
    } else {
      console.error('No data returned');
      return [];
    }
  } catch {
    console.error('Server is not running or has a fault');
    return [];
  }
}
